import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="overflow-hidden rounded-lg border border-background-300 bg-background-50">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div
            key={item.q}
            className={`border-b border-background-200 last:border-b-0 ${
              open ? "bg-background-100" : ""
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center font-label text-xs font-bold text-primary-600">
                    Q
                  </span>
                  <span className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                </span>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                  <i
                    className={
                      open ? "ri-subtract-line text-lg" : "ri-add-line text-lg"
                    }
                  />
                </span>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-5 pl-12 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6 md:pl-14">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}